import React, { Component } from "react";
import PropTypes from 'prop-types';
import ArticleResult from "./ArticleResult"
import Masonry from "../elements/Masonry"
import { getStyleTag, getStyles } from '../../styles/dynamicStyles';

class Results extends Component {

  static propTypes = {
    urlParams: PropTypes.object,
  }

  render() {
    const { articleStyle, className } = this.props

    const results = this.results()

    return (
      <section
        className={`search-results__listings ${className}`}
        data-article-style={articleStyle}
        style={getStyles(['search-results__listings', 'search-results__listings-search'])}
      >
        {getStyleTag(['search-results__listings', 'search-results__listings-search'])}
          <Masonry
            ref={c => {
              if (c) this.masonry = c
            }}
          >
            {results}
          </Masonry>
      </section>
    )
  }

  results = () => {
    return this.props.resources.map(resource => (
      <ArticleResult
        key={resource.id}
        cursor={resource.id}
        resource={resource}
        images={resource.cover_image}
        itemUrl={`/collections/${resource.slug}`}
      />
    ))
  }

  masonryLayout = () => {
    if (this.masonry) {
      this.masonry.masonryLayout()
    }
  }
}

export default Results



// WEBPACK FOOTER //
// ./webapp/components/modules/ResultsWithoutPagination.js